import "./App.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import ComponentsRoutes from "./ComponentsRoutes";

function Layout() {
  const location = useLocation();
  const hideLayout =
    location.pathname === "/admin-login" || location.pathname === "/";

  const [isExpanded, setExpanded] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // 🔥 Resize + zoom safe logic
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024; // lg breakpoint
      setIsMobile(mobile);

      if (mobile) {
        setExpanded(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="h-screen overflow-hidden bg-slate-100">
      {/* Navbar */}
      {!hideLayout && (
        <Navbar isExpanded={isExpanded} setExpanded={setExpanded} />
      )}

      <div className={`flex ${hideLayout ? "h-full" : "h-[calc(100vh-56px)]"}`}>
        {/* ================= SIDEBAR ================= */}
        {!hideLayout && (
          <>
            {/* Desktop Sidebar */}
            {!isMobile && (
              <aside
                className={`
                  shrink-0 bg-white border-r
                  transition-all duration-300 ease-in-out
                  ${isExpanded ? "w-64" : "w-16"}
                `}
              >
                <Sidebar isExpanded={isExpanded} setExpanded={setExpanded} />
              </aside>
            )}

            {/* Mobile Sidebar Drawer */}
            {isMobile && (
              <>
                <aside
                  className={`
                    fixed inset-y-0 left-0 z-40 w-64 bg-white border-r
                    transform transition-transform duration-300 ease-in-out
                    ${isExpanded ? "translate-x-0" : "-translate-x-full"}
                  `}
                >
                  <Sidebar isExpanded={true} setExpanded={setExpanded} />
                </aside>

                {/* Overlay */}
                {isExpanded && (
                  <div
                    className="fixed inset-0 bg-black/40 z-30"
                    onClick={() => setExpanded(false)}
                  />
                )}
              </>
            )}
          </>
        )}

        {/* ================= MAIN CONTENT ================= */}
        <main className="flex-1 overflow-y-auto">
          <ComponentsRoutes />
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
